import { render } from "./PanelTipsterSuscripciones.vue?vue&type=template&id=66e28287&scoped=true"
import script from "./PanelTipsterSuscripciones.vue?vue&type=script&lang=js"
export * from "./PanelTipsterSuscripciones.vue?vue&type=script&lang=js"

import "./PanelTipsterSuscripciones.vue?vue&type=style&index=0&id=66e28287&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e28287"]])

export default __exports__